import { postRequest, postFormDataRequest } from "../apiHelpers";
import {
	getRequestNotification, addRequestNotification, deleteRequestNotification, requestNotificationById,
	getNotificationErrorById
} from "../pathApi";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const callGetRequestNotification = createAsyncThunk(getRequestNotification, async (body) => {
	try {
		const response = await postRequest({ url: getRequestNotification, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callAddRequestNotification = createAsyncThunk(addRequestNotification, async (body) => {
	try {
		const response = await postRequest({ url: addRequestNotification, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callDeleteRequestNotification = createAsyncThunk(deleteRequestNotification, async (body) => {
	try {
		const response = await postRequest({ url: deleteRequestNotification, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callRequestNotificationById = createAsyncThunk(requestNotificationById, async (body) => {
	try {
		const response = await postRequest({ url: requestNotificationById, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetNotificationErrorById = createAsyncThunk(getNotificationErrorById, async (body) => {
	try {
		const response = await postRequest({ url: getNotificationErrorById, data: body });
		return response;
	} catch (error) {
		throw error
	}
});